module.exports = __webpack_public_path__ + "static/img/社會師資介紹.6f10fcfa.png";